<div class="loading-spinner-container" *ngIf="skLoading"><mat-spinner diameter="64"></mat-spinner></div><ng-content></ng-content>